'use client';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

import { CapitalRequest, SRStatus } from '@scaleup/models';
import { useGetCapitalRequestsQuery } from '../../api';
import { toTitleCase } from '../../utils';
import { CapitalRequestDealTracker } from './CapitalRequestDealTracker';

export const CapitalRequestLists = ({
  filter,
}: {
  filter?: 'active' | 'previous' | 'draft';
}) => {
  const router = useRouter();
  const { data: capitalRequests } = useGetCapitalRequestsQuery();
  const [filteredCapitalRequests, setFilteredCapitalRequests] = useState<
    CapitalRequest[]
  >([]);

  useEffect(() => {
    if (filter) {
      switch (filter) {
        case 'active':
          setFilteredCapitalRequests(
            capitalRequests?.filter(
              (request: any) =>
                request.status === SRStatus.ACTIVE) ?? []
          );
          break;
        case 'previous':
          setFilteredCapitalRequests(
            capitalRequests?.filter(
              (request: any) =>
                request.status === SRStatus.ARCHIVED
            ) ?? []
          );
          break;
        case 'draft':
          setFilteredCapitalRequests(
            capitalRequests?.filter(
              (request: any) => request.status === SRStatus.DRAFT
            ) ?? []
          );
          break;
        default:
          setFilteredCapitalRequests(
            capitalRequests?.filter(
              (request: any) =>
                request.status !== SRStatus.DRAFT
            ) ?? []
          );
          break;
      }
    }
  }, [filter, capitalRequests]);

  return (
    <>
      {filteredCapitalRequests.map((capitalRequest) => {
        return (
          <div
            key={capitalRequest.requestId}
            onClick={() =>
              capitalRequest.status !== SRStatus.DRAFT &&
              router.push(
                `/supplier/capital-requests/${capitalRequest.requestId}`
              )
            }
            className="flex-1 rounded-[2rem] bg-white p-8"
          >
            <div className="flex gap-8 flex-col">
              <div className="flex gap-2 flex-col">
                <div className="w-full flex justify-between	items-center gap-2">
                  <h2 className="text-xl w-full font-bold">Capital Request</h2>
                  {capitalRequest.status !== SRStatus.DRAFT && (
                    <CapitalRequestDealTracker status={capitalRequest.status} />
                  )}
                </div>
              </div>
              {capitalRequest.status !== SRStatus.DRAFT && (
                <div className="flex flex-col gap-8">
                  <div className="bg-gray-25 rounded-2xl flex p-4 flex-col items-start gap-2">
                    <Image
                      src="/icons/expense-green.svg"
                      width={24}
                      height={24}
                      alt=""
                    />
                    <span className="font-bold">Amount Needed</span>
                    <div className="rounded-2xl bg-success-50 text-success-700 px-3 py-2 w-fit">
                      <span className="text-sm">
                        ${capitalRequest.capitalNeed}
                      </span>
                    </div>
                  </div>
                  <div className="bg-gray-25 rounded-2xl flex p-4 flex-col items-start gap-2">
                    <Image
                      src="/icons/invest-green.svg"
                      width={24}
                      height={24}
                      alt=""
                    />
                    <span className="font-bold">Request Breakdown</span>
                    <div className="flex flex-wrap gap-2">
                      {capitalRequest.capitalNeedList.map((item, index) => (
                        <div
                          className="rounded-2xl bg-primary-50 text-primary-700 px-3 py-2 w-fit"
                          key={index}
                        >
                          <span className="text-sm">
                            {toTitleCase(item.description.split('_').join(' '))}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};
